import axios from "axios";
import { BASE_API_URL } from "../utils/api-url";

export async function getZones(accessToken) {
  const result = await axios.get(`${BASE_API_URL}/zones`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return result.data;
}

export async function createZone(accessToken, data) {
  const result = await axios({
    method: "POST",
    url: `${BASE_API_URL}/zones`,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    data,
  });

  return result;
}

export async function createUserZone(accessToken, data) {
  const result = await axios({
    method: "POST",
    url: `${BASE_API_URL}/zoneuser`,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    data,
  });

  return result;
}

export async function updateUserZone(accessToken, data) {
  const result = await axios({
    method: "PUT",
    url: `${BASE_API_URL}/zoneuser`,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    data,
  });

  return result;
}

export async function deleteUserZone(accessToken, data) {
  const result = await axios({
    method: "DELETE",
    url: `${BASE_API_URL}/zoneuser`,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    data,
  });

  return result;
}
